export const RESET_DOMAIN_LECTURES = 'domain-lectures/RESET_DOMAIN_LECTURES';
export const RESET_DOMAIN_LECTURES_POSITION = 'domain-lectures/RESET_DOMAIN_LECTURES_POSITION';
export const SET_DOMAIN_LECTURES = 'domain-lectures/SET_DOMAIN_LECTURES';
export const SET_LEARNING_ELEMENT = 'domain-lectures/SET_LEARNING_ELEMENT';




// WEBPACK FOOTER //
// ./src/app/domain-lecture/store/mutation-types.js